<template>
  <v-layout column>
        <v-tabs
          v-model="tab"
          align-with-title
        >
          <v-tabs-slider color=""></v-tabs-slider>

          <v-tab v-for="item in items" :key="item">
            {{ item }}
          </v-tab>
        </v-tabs>


    <v-tabs-items v-model="tab">
      <v-tab-item
        v-for="item in items"
        :key="item"
      >
        <v-card flat style="max-width:100%;" class="item-list">
          <v-card-text v-if="tab == 0">
              <h2 style="text-align: center; margin-bottom: 2rem;">CURRENT SHIFTS</h2>
              <div v-if="gettingShifts">
                <v-progress-linear indeterminate>
                </v-progress-linear>
              </div>
              <div v-else>
                <v-flex v-for="shift in currentShifts" :key="shift.id">
                  <ClientTabsShiftItem
                    showIcon
                    :itemData="shift"
                  />

                </v-flex>
              </div>
          </v-card-text>
          <!-- <v-card-text v-if="tab == 1">
              Laundry
          </v-card-text>
          <v-card-text v-if="tab == 2">
              Book Keeping
          </v-card-text> -->
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </v-layout>
</template>

<script>
import { mapState, mapGetters  } from 'vuex'
import shiftApi from '@/api/shift'
import ShiftItem from '@/components/dashboard/shift-item.vue'
import ClientTabsShiftItem from '@/components/dashboard/client-tabs-shift-item.vue'
import TaskItem from '@/components/dashboard/task-item.vue'

export default {
  components: {
    ClientTabsShiftItem,
    ShiftItem,
    TaskItem
  },
  created () {
    // console.log(this.shifts)
    this.setUp()
  },
  computed: {
    ...mapState('userAuth', [
      'user'
    ]),
    activityItems () {
      return this.shifts
    },
    formattedQuery: function () {
      return {
        startDate: this.startDate,
        endDate: this.endDate,
        locationFilter: this.selectedLocationFilter
      }
    },
  },
  methods: {
    // getShifts: function () {
    //     const params = this.formattedQuery
    //     this.$store.dispatch('shifts/getList', params)
    //     .then(res => {
    //         this.shifts = res.shifts
    //     })
    //     .finally(res => {
    //     })
    // },
    setUp: function () {
      this.startDate = this.startDate
      this.endDate = this.endDate
      this.selectedLocationFilter = this.user.clientWorksiteIds
      this.setOffShiftChecker()
    },
    setOffShiftChecker () {
      this.getCurrentShifts()
      let interval = 600000 // every 10 minutes
      this.shiftGetter = setInterval(function() {
        this.getCurrentShifts()
      }.bind(this), interval)
    },
    getCurrentShifts() {
      this.gettingShifts = true
      shiftApi.getCurrentForClient(this.user.id, shifts => {
        this.currentShifts = shifts
        this.gettingShifts = false
      },
      error => {
        console.log(error)
        this.gettingShifts = true
      })
    },
  },
  data: function () {
    return {
        selectedLocationFilter: null,
        startDate: this.$moment().format("YYYY-MM-DD"),
        endDate: this.$moment().add(1, "day").format("YYYY-MM-DD"),
        shifts: [],
        tab: null,
        items: [
          // 'Staffing', 'Laundry', 'Book Keeping',
          'Staffing'
        ],
        text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
        currentShifts: [],
        currentShiftInterval: null,
        gettingShifts: false,
      }
    },
  }
</script>

<style scoped>
  .item-list{
    overflow: auto;
    max-height: calc(50vh - 111px); /* TODO: this is a hack. need to set up a fixed height viewport */
  }
</style>